import React from "react";
import { useAddParentModal } from "./hooks";
import { Grid } from "@material-ui/core";
import AppModal from "../../../modals/app-modal";
import FormDropdown from "../../../../base/form-dropdown";
import FormTextInput from "../../../../base/form-text-input";
import { isFunction } from "@utils";

import "./style.css";

const AddParentInfoModal = ({
  parentType = "",
  closeModal,
  advertisement,
  refreshAdData,
}) => {
  const {
    ethnicities,
    religions,
    residentCountries,
    professions,
    FormDef,
    onchange,
    values,
    errors,
    handleFormSubmit,
    isFieldVisible,
    resetValues,
  } = useAddParentModal({ closeModal, refreshAdData });

  const handleCloseModal = () => {
    if (isFunction(resetValues)) {
      resetValues();
    }
    if (isFunction(closeModal)) {
      closeModal();
    }
  };

  const title = `Add ${parentType.toLowerCase()}'s info`;

  return (
    <AppModal
      visibility={Boolean(parentType)}
      title={title}
      modalClasses="add-parents-info-modal"
      onPrimaryAction={() =>
        handleFormSubmit({ parentType, postId: advertisement?.id })
      }
      handleClose={handleCloseModal}
      onSecondaryAction={handleCloseModal}
    >
      <Grid container direction="row" className="pb-16 gap-y-8">
        <FormDropdown
          name={FormDef.ethnicityId.fieldName}
          label={FormDef.ethnicityId.label}
          options={ethnicities}
          onChangeValue={onchange}
          value={values[FormDef.ethnicityId.fieldName]}
          errorText={errors[FormDef.ethnicityId.fieldName]}
          required={FormDef.ethnicityId.required}
        />
        <FormDropdown
          name={FormDef.religionId.fieldName}
          label={FormDef.religionId.label}
          options={religions}
          onChangeValue={onchange}
          value={values[FormDef.religionId.fieldName]}
          errorText={errors[FormDef.religionId.fieldName]}
          required={FormDef.religionId.required}
        />
        <FormTextInput
          name={FormDef.caste.fieldName}
          label={FormDef.caste.label}
          onChangeInput={onchange}
          value={values[FormDef.caste.fieldName]}
          errorText={errors[FormDef.caste.fieldName]}
          required={FormDef.caste.required}
        />
        <FormDropdown
          name={FormDef.professionId.fieldName}
          label={FormDef.professionId.label}
          options={professions}
          onChangeValue={onchange}
          value={values[FormDef.professionId.fieldName]}
          errorText={errors[FormDef.professionId.fieldName]}
          required={FormDef.professionId.required}
        />
        {isFieldVisible(FormDef.otherProfession.fieldName) && (
          <FormTextInput
            name={FormDef.otherProfession.fieldName}
            label={FormDef.otherProfession.label}
            onChangeInput={onchange}
            value={values[FormDef.otherProfession.fieldName]}
            errorText={errors[FormDef.otherProfession.fieldName]}
            required={FormDef.otherProfession.required}
          />
        )}
        <FormDropdown
          name={FormDef.residentCountryCode.fieldName}
          label={FormDef.residentCountryCode.label}
          options={residentCountries}
          onChangeValue={onchange}
          value={values[FormDef.residentCountryCode.fieldName]}
          errorText={errors[FormDef.residentCountryCode.fieldName]}
          required={FormDef.residentCountryCode.required}
        />
        <FormTextInput
          name={FormDef.additionalInfo.fieldName}
          label={FormDef.additionalInfo.label}
          onChangeInput={onchange}
          value={values[FormDef.additionalInfo.fieldName]}
          errorText={errors[FormDef.additionalInfo.fieldName]}
          required={FormDef.additionalInfo.required}
          maxLength={FormDef.additionalInfo.maxLength}
          multiline
        />
      </Grid>
    </AppModal>
  );
};

export default AddParentInfoModal;
